import { render, staticRenderFns } from "./ManageRoom.vue?vue&type=template&id=281fc112&scoped=true&"
import script from "./ManageRoom.vue?vue&type=script&lang=js&"
export * from "./ManageRoom.vue?vue&type=script&lang=js&"
import style0 from "./ManageRoom.vue?vue&type=style&index=0&id=281fc112&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281fc112",
  null
  
)

export default component.exports